/* unplugin-vue-components disabled */import script from "./side-code.vue?vue&type=script&lang=jsx"
export * from "./side-code.vue?vue&type=script&lang=jsx"

import "./side-code.vue?vue&type=style&index=0&id=1c833ac4&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c833ac4"]])

export default __exports__